<template>
  <transition name="slide">
    <v-card v-if="show" class="drawer">
      <Ride
        v-if="drawer === 'ride'"
        :data="drawerData"
        :history="history"
        :filters="filters"
        @goBack="goBack"
        @close="close"
        @change="changeDrawer"
        @updateHistory="updateHistory"
      />

      <CostCenter
        v-if="drawer === 'costCenter'"
        :data="drawerData"
        :drawerType="lastDrawerType"
        :history="history"
        :filters="filters"
        @goBack="goBack"
        @close="close"
        @change="changeDrawer"
        @updateHistory="updateHistory"
      />

      <Employee
        v-if="drawer === 'employee'"
        :data="drawerData"
        :drawerType="lastDrawerType"
        :history="history"
        :filters="filters"
        @goBack="goBack"
        @close="close"
        @change="changeDrawer"
        @updateHistory="updateHistory"
      />

      <Project
        v-if="drawer === 'project'"
        :data="drawerData"
        :actionType="actionType"
        :drawerType="lastDrawerType"
        :history="history"
        @goBack="goBack"
        @close="close"
        @change="changeDrawer"
        @updateHistory="updateHistory"
      />

      <Financial
        v-if="drawer === 'financial'"
        :data="drawerData"
        :drawerType="lastDrawerType"
        :history="history"
        :filters="filters"
        @goBack="goBack"
        @close="close"
        @change="changeDrawer"
        @updateHistory="updateHistory"
      />

      <PaymentMethod
        v-if="drawer === 'paymentMethod'"
        :data="drawerData"
        :drawerType="lastDrawerType"
        :history="history"
        :filters="filters"
        @goBack="goBack"
        @close="close"
        @change="changeDrawer"
        @updateHistory="updateHistory"
      />

      <Voucher
        v-if="drawer === 'voucher'"
        :data="drawerData"
        :actionType="actionType"
        :drawerType="lastDrawerType"
        :history="history"
        :filters="filters"
        @goBack="goBack"
        @close="close"
        @change="changeDrawer"
        @updateHistory="updateHistory"
      />

      <TimePolicy
        v-if="drawer === 'timePolicy'"
        :data="drawerData"
        :drawerType="lastDrawerType"
        :history="history"
        :filters="filters"
        @goBack="goBack"
        @close="close"
        @change="changeDrawer"
        @updateHistory="updateHistory"
      />

      <CompanyGroup
        v-if="drawer === 'companyGroup'"
        :data="drawerData"
        :drawerType="lastDrawerType"
        :history="history"
        :filters="filters"
        @goBack="goBack"
        @close="close"
        @change="changeDrawer"
        @updateHistory="updateHistory"
      />
    </v-card>
  </transition>
</template>

<script>
import { isValidArray } from 'corp-front-vue-commons/src/utils/functions'
import Ride from './Ride'
import CostCenter from './CostCenter'
import Employee from './Employee'
import Project from './Project'
import Financial from './Financial'
import PaymentMethod from './PaymentMethod'
import Voucher from './Voucher'
import TimePolicy from './TimePolicy'
import CompanyGroup from './CompanyGroup'
import './styles.scss'

export default {
  name: 'GlobalDrawer',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {}
    },
    drawerType: {
      type: String,
      required: true
    },
    filters: {
      type: Object
    },
    actionType: {
      type: String,
      default: 'preview'
    }
  },
  components: {
    Ride,
    CostCenter,
    Employee,
    Project,
    Financial,
    PaymentMethod,
    Voucher,
    TimePolicy,
    CompanyGroup
  },
  computed: {
    lastDrawerType () {
      const historyLength = this.history.length
      return this.isValidArray(this.history) ? this.history[historyLength - 1].drawerType : ''
    }
  },
  data () {
    return {
      history: [],
      drawer: null,
      drawerData: {}
    }
  },
  methods: {
    isValidArray (val) {
      return isValidArray(val)
    },

    goBack () {
      // remove last item
      this.history.pop()
      const lastItemHistory = this.history.length - 1
      const target = this.history[lastItemHistory]
      this.drawerData = target.data
      this.setDrawerType(target.drawerType)
    },

    resetHistory () {
      this.history = []
    },

    close (reload) {
      this.resetHistory()
      this.$emit('close', reload)
    },

    setDrawerType (val) {
      this.drawer = val
    },

    changeDrawer ({ drawer, data }) {
      this.drawerData = data
      this.setDrawerType(drawer.type)
      this.updateHistory({ drawerType: drawer.type, data })
    },

    updateHistory ({ drawerType, data }) {
      if (!this.history.length) {
        return this.history.push({
          drawerType,
          data
        })
      }

      const lastItemHistory = this.history.length - 1
      const lastItemHistoryDrawerType = this.history[lastItemHistory].drawerType

      if (lastItemHistoryDrawerType !== drawerType) {
        this.history.push({
          drawerType,
          data
        })
      }
    }
  },
  mounted () {
    this.setDrawerType(this.drawerType)
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.drawerData = val
        this.setDrawerType(this.drawerType)
      }
    }
  }
}
</script>
